import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {doc, updateDoc} from 'firebase/firestore'
import Button from 'app/components/Button'
import {showErrorToast, showSuccessToast} from 'app/components/ShowToast'
import { useAuth } from 'app/modules/auth'
import db from 'services/firebase'

interface DeactivatingProps {
  isOpen: boolean
  onClose: () => void
  id: string
  type?: 'control' | 'test'
  title?: string
  policyID?: string
}

const Deactivate: React.FC<DeactivatingProps> = ({isOpen, onClose, id, type = 'control', title,policyID}) => {
  const [showModal, setShowModal] = useState(false)
  const {currentUser} = useAuth()
  const [deactivationDetail, setDeactivationDetail] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setShowModal(isOpen)
  }, [isOpen])

  const handleClose = () => {
    setShowModal(false)
    onClose()
  }

  const handleChange = (e) => {
    setDeactivationDetail(e.target.value)
  }

  const handleDeactivateActivate = async () => {
    try {
      setIsLoading(true)

      const tenantId = currentUser?.tenantId || ''
      const collectionPath = type === 'control' ? 'controls' : 'tests'
      const docRef = doc(db, `tenants/${tenantId}/${collectionPath}/${id}`)
      
      const updateData = {
        [type === 'control' ? 'control_evidence_status' : 'status']: 'Deactivated',
        [type === 'control' ? 'deactivation_control' : 'deactivation_reason']: deactivationDetail,
      }
      
      await updateDoc(docRef, updateData)

      if (type === 'test' && policyID) {
          const policyRef = doc(db, `tenants/${tenantId}/policies/${policyID}`)
          await updateDoc(policyRef, {
            status: 'Deactivated'
          })
      }

      handleClose()
      setDeactivationDetail('')
      setIsLoading(false)
      showSuccessToast({message: `${title || type} deactivated successfully!`})
    } catch (error) {
      showErrorToast({message: `Failed to deactivate ${type}`})
    }
  }

  return (
    <Modal show={showModal} onHide={handleClose} backdropClassName='bg-opacity-1' centered>
      <Modal.Header>
        <Modal.Title>Deactivate {title || type}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='fs-5 fw-bold mb-3'>
          Why do you want to deactivate monitoring for this {type}?{' '}
        </div>
        <div className='fs-6' style={{color: '#5A5A5A'}}>
          Disabling monitoring will stop SecureSlate's automatic oversight of {type === 'control' ? 'these controls' : 'these tests'} and
          remove them from your list of failing {type}s. Only disable monitoring if you have other
          measures in place or if this {type} is not relevant to your organization.
          <p className='mt-3'>Please note that this action can be reversed.</p>
        </div>
        <div className='fv-row mb-2 mt-7'>
          <label className='fw-bold fs-6 mb-2 required'>Reason for deactivating this {type}</label>
          <textarea
            placeholder='This is not applicable to us because...'
            className='form-control mb-3 mb-lg-0 w-100'
            name='deactivationDetail'
            value={deactivationDetail}
            onChange={handleChange}
            autoComplete='off'
            required
          />
        </div>
      </Modal.Body>
      <Modal.Footer className='p-0 px-6 py-4 gap-2'>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          btnType='destructive'
          onClick={handleDeactivateActivate}
          disabled={deactivationDetail === '' || isLoading}
        >
          {isLoading ? (
            <>
              Deactivating...{' '}
              <span className='spinner-border spinner-border-sm align-middle'></span>
            </>
          ) : (
            'Deactivate'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default Deactivate